import React, { useState, useRef, useEffect } from 'react';

// D-082: one login may reach several organisations. This selects which one the
// portal is looking at - it grants nothing. Reachability is re-verified
// server-side on every call, so the list is never cached or trusted locally.
function OrgSwitcher({ orgs, activeGido, onSelect }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function onClickAway(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', onClickAway);
    return () => document.removeEventListener('mousedown', onClickAway);
  }, []);

  // Nothing to switch between - render the plain badge, as before.
  if (!orgs || orgs.length === 0) {
    return <span className="gido-badge">{activeGido}</span>;
  }

  const active = orgs.find((o) => o.gido_id === activeGido);

  function label(o) {
    if (o.is_owner) return 'your organisation';
    return o.access_source === 'consultant' ? 'consultant' : 'seat';
  }

  return (
    <div className="org-switcher" ref={ref}>
      <button
        className="gido-badge org-switcher-trigger"
        onClick={() => setOpen((v) => !v)}
        title={active?.name || activeGido}
      >
        {activeGido} <span className="org-switcher-caret">▾</span>
      </button>

      {open && (
        <div className="org-switcher-menu">
          {orgs.map((o) => (
            <button
              key={o.gido_id}
              className={`org-switcher-item${o.gido_id === activeGido ? ' is-active' : ''}`}
              onClick={() => { setOpen(false); if (o.gido_id !== activeGido) onSelect(o.gido_id); }}
            >
              <span className="org-switcher-name">{o.name || o.gido_id}</span>
              <span className="org-switcher-meta">
                {o.gido_id} · {label(o)}
                {o.expires_at && ` · until ${new Date(o.expires_at).toLocaleDateString('en-IE')}`}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default OrgSwitcher;